<template>
    <Header
        elements="9"
        current="8"
    ></Header>
    <div class="MuiBox-root css-3d0ymh">
        <div class="MuiBox-root css-19vwmxk" data-testid="screen-business_details" tabindex="-1">
            <div class="MuiBox-root css-1n2tziu">
                <div class="MuiGrid-root MuiGrid-container css-15zova9 slide-up-enter-done" transition="250">
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-ms-3 MuiGrid-grid-md-4 css-4lvwcn">
                        <div class="MuiBox-root css-1yu9eo3">
                            <div class="MuiGrid-root css-skpbsy">
                                <div class="MuiGrid-root css-vnk25j" type="lottie">
                                    <div>
                                        <Freezeframe
                                            src="/images/free-animated-icon-fast-forward-7740748.gif"
                                        ></Freezeframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-ms-1 css-se8e58">
                        <div class="MuiBox-root css-8atqhb"></div>
                    </div>
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-4 MuiGrid-grid-md-7 css-xjtbym">
                        <div class="checkDetail">
                            <h1>Please review the Office Action Response Package for Trademark Serial No. {{ number }}</h1>
                            <div class="topSpace">
                                <div class="MuiBox-root css-1rrbnz radio-checkbox-block">
                                    <RadioCheckbox
                                        :disabled="start_package_type == PACKAGE_UMBRELLA"
                                        :value="package_type"
                                        @change_c="package_type = $event"
                                        type="radio"
                                        :value_v="PACKAGE_BASIC"
                                        text="Basic Office Action"
                                        name="package_type"
                                    ></RadioCheckbox>
                                    <RadioCheckbox
                                        :disabled="start_package_type == PACKAGE_BASIC"
                                        :value="package_type"
                                        @change_c="package_type = $event"
                                        type="radio"
                                        :value_v="PACKAGE_UMBRELLA"
                                        text="Umbrella Office Action"
                                        name="package_type"
                                    ></RadioCheckbox>
                                </div>
                                <p class="note note-success topSpace mb-d d-block">
                                    <template v-if="package_type == PACKAGE_UMBRELLA">
                                        Based on the requirements set forth in your Office Action, you will require the "Umbrella Office Action Response". This is a comprehensive response involving the drafting of a Legal Brief arguing against the objections raised by the Examining Attorney who issued the Office Action.
                                    </template>
                                    <template v-if="package_type == PACKAGE_BASIC">
                                        Based on the requirements set forth in your Office Action, you will require the "Basic Office Action Response". This is a comprehensive response involving the drafting of a Legal Brief arguing against the objections raised by the Examining Attorney who issued the Office Action.
                                    </template>
                                </p>
                                <p class="note note-success topSpace">
                                    <template v-if="package_type == PACKAGE_BASIC">
                                        <span style="display:block; margin-bottom:8px;">If it turns out that your Office Action Requires an "Umbrella Office Action Response", our team will be in touch and discuss this with you and any additional fees due.</span>
                                    </template>
                                    <span style="display:block; margin-bottom:12px;"><b>Basic Office Action ($250.00):</b>Appropriate for office actions with minor “procedural” issues, including Disclaimers, Descriptions of products/services etc.</span>
                                    <span style="display:block; margin-bottom:8px;"><b>Umbrella Office Action ($850.00):</b> Appropriate for complex Office Actions, including Likelihood of Confusion and Merely Descriptive objections. In order to respond to these objections, our lawyers will draft Legal Briefs, often several pages in length and accompanied by Exhibits and cost $850.00</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="css-1l6i970">
                <div class="css-1c73k7k">
                    <BottomButton
                        :active="true"
                        @click.native="back"
                        text="Back"
                        class_b="button-back"
                    ></BottomButton>
                    <BottomButton
                        :active="true"
                        @click.native="next"
                        text="Next"
                        class_b="button-next"
                    ></BottomButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header-Short-New.vue'
import RadioCheckbox from '@/ui/Radio-Checkbox.vue'
import http from "@/api/http";
import BottomButton from '@/ui/Bottom-Button.vue'
import Freezeframe from '@/components/Freezeframe.vue'
import {to_top} from "@/helper";

const PACKAGE_BASIC = 'B';
const PACKAGE_UMBRELLA = 'U';

export default {
    components: {
        Header,
        BottomButton,
        RadioCheckbox,
        Freezeframe
    },
    data() {
        return {
            number: '',
            PACKAGE_BASIC: PACKAGE_BASIC,
            PACKAGE_UMBRELLA: PACKAGE_UMBRELLA,
            package_type: PACKAGE_BASIC,
            start_package_type: PACKAGE_BASIC
        }
    },
    mounted() {
        to_top()
        this.init()
    },
    methods: {
        async init() {
            let { data } = await http.get('trademark-office-action/step-6/' + this.$route.params.key);

            if (data.res) {
                this.number = data.data.data.number
                this.package_type = data.data.data.package_type
                this.start_package_type = data.data.data.package_type

                this.$store.commit('header/setTotal', data.data.data.total)
            }
        },
        async next() {
            let { data } = await http.put('trademark-office-action/step-6/' + this.$route.params.key);

            if (data.res) {
                this.$router.push({ path: '/trademark-office-action/step-pay/' + this.$route.params.key })
            }
        },
        back() {
            this.$router.push({ path: '/trademark-office-action/step-5/' + this.$route.params.key })
        }
    }
}
</script>

<style>
.card-body, .card-body p, .card-body div, .card-body ul li, .card-body ol li {
    font-size: 12px;
}

input.disabled-radio, span.aspNetDisabled {
    pointer-events: none;
    opacity: 0.5;
}
.radio-checkbox-block .radio-checkbox_checked .css-gr1e5v {
    background-color: #16bdc6;
}
</style>
